<template>
  <div class="success">
    <div class="jumbotron text-center" id="suc">
      <div class="imgg">
      <img src="@/assets/img/cart_.jpg" class=""  height="250" width="250" />
      </div>
      <h2><b>Order Summary</b></h2>
      <table class="cen">
        <thead>
          <tr>
            <th>PRODUCT</th>
            <th>QUANTITY</th>
            <th>PRICE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td id="prod0"></td>
            <td id="prodqty0"></td>
            <td id="prodprice0"></td>
          </tr>
          <tr>
            <td id="prod1"></td>
            <td id="prodqty1"></td>
            <td id="prodprice1"></td>
          </tr>
          <tr>
            <td id="prod2"></td>
            <td id="prodqty2"></td>
            <td id="prodprice2"></td>
          </tr>
          <tr>
            <td id="prod3"></td>
            <td id="prodqty3"></td>
            <td id="prodprice3"></td>
          </tr>
          <tr>
            <td>TOTAL</td>
            <td>--</td>
            <td id="totalPrice"><b></b></td>
          </tr>
        </tbody>
      </table>
      <p class="lead">
        <router-link
          class="btn btn-primary"
          :to="'/' + $i18n.locale + '/success'"
          role="button"
          id="colsecondbtn"
          >Jetzt bestellen</router-link
        >
        <router-link
          class="btn btn-primary"
          :to="'/' + $i18n.locale"
          role="button"
          id="colsecondbtn"
          >Zurück zur Startseite</router-link
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Success",
  mounted() {
    // Load cart products from localStorage and populate table
    try {
      const raw = window.localStorage.getItem("vuex");
      if (raw) {
        const a = JSON.parse(raw);
        const b = a && a.cartProducts ? a.cartProducts : null;
        if (b && Array.isArray(b)) {
          let sum = 0;
          for (let i = 0; i < b.length; i++) {
            const prodEl = document.getElementById("prod" + i);
            const qtyEl = document.getElementById("prodqty" + i);
            const priceEl = document.getElementById("prodprice" + i);
            if (prodEl) prodEl.innerHTML = b[i].title || "";
            if (qtyEl) qtyEl.innerHTML = b[i].qty != null ? b[i].qty : "";
            if (priceEl) priceEl.innerHTML = "€ " + String(b[i].price).replace(".", ",");
            sum += (b[i].price || 0) * (b[i].qty || 0);
          }
          const totalEl = document.getElementById("totalPrice");
          if (totalEl) totalEl.innerHTML = "€ " + Math.round(sum);
        }
      }
    } catch (e) {
      // silently ignore errors
    }

    if (localStorage.getItem("reloaded")) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem("reloaded");
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
  }
};
</script>
<style scoped>
#col {
  background-color: #1BADA2;
}
#coll {
  text-emphasis-color: #1BADA2;
}
#suc {
  background-color: white;
  /* background-image: url("../../assets/img/confetti.png"); */
}
.cen {
  margin-left: auto;
  margin-right: auto;
}
table {
  border-collapse: collapse;
  width: 40%;
}

th, td {
  text-align: left;
  padding: 8px;
}
#colsecondbtn {
  background-color: #1BADA2;
  margin-left: 20px;
  margin-top: 20px;
  max-width: 200px;
  min-width: 200px;
  border: none;
}
tr {
  background-color: #ffffff;
}

th {
  background-color: #1BADA2;
  color: white;
}
</style>
